module.exports = __webpack_public_path__ + "img/ic-96333-point.302285b3.png";